import MedicalAdapter from './base';

export default class Log extends MedicalAdapter {
  modelNamePlural = 'logs';
}
